/**
 * Schema.org BreadcrumbList JSON-LD builder (SSoT).
 *
 * Breadcrumb JSON-LD üç ayrı yerde İNLİNE kopyalanmıştı:
 *   - ToolHead.tsx (Ana Sayfa › Araçlar › <tool>)
 *   - araclar/index.js (Ana Sayfa › Araçlar)
 *   - risk-analizi/ornekler/index.tsx (Ana Sayfa › Risk Analizi Örnekleri)
 * Her biri aynı `BreadcrumbList` + `ListItem` + `position` deseni → drift riski.
 * Bu helper tek SSoT: caller `{ name, url }[]` dizisi geçer (URL'ler zaten
 * absolute — domain hardcode bu helper'da YOK, caller KURUMSAL_KIMLIK.url ile kurar).
 *
 * Mapping: { name, url } → ListItem (position 1-based) → BreadcrumbList.
 * Boş name/url filtrelenir. Dizi boşsa null döner (script render edilmez).
 *
 * @module shared/schema/breadcrumbSchema
 */

export interface BreadcrumbItem {
  name: string;
  url: string;
}

export function buildBreadcrumbSchema(items: readonly BreadcrumbItem[] | BreadcrumbItem[]) {
  const liste = (items || []).filter((i) => i && i.name && i.url);
  if (liste.length === 0) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: liste.map((i, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: i.name,
      item: i.url,
    })),
  };
}
